
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","stroke":"#515358"}}),_c('path',{attrs:{"d":"M27.28 35.359h-2.46v-22.45a1.67 1.67 0 10-2.79-1.25 1.65 1.65 0 00.56 1.25v22.45h-2.46c-.07 0-.13.19-.13.43v.85c0 .24.06.44.13.44h7.15c.06 0 .12-.19.12-.44v-.85c0-.24-.06-.43-.12-.43z","fill":"#515358"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/designer_layers_svgs/pole.svg